<template>
  <div class="card">
    <div class="card-content">
      <question-title :question="question" class="mb1"></question-title>

      <div class="control mt1">
        <masked-input
          class="input"
          type="tel"
          placeholder="Zip"
          placeholderChar="_"
          :mask="[/\d/, /\d/, /\d/, /\d/, /\d/]"
          name="zip"
          v-model="choice"
          @keyup.native="recordAnswer"
        >
        </masked-input>
      </div>

      <next-button :id="question.id" :choice="choice"></next-button>
    </div>
  </div>
</template>

<script>
import maskedInput from "vue-text-mask";
import baseQuestion from "./baseQuestion";

export default {
  name: "zip",

  mixins: [baseQuestion],

  components: {
    maskedInput
  },

  methods: {
    recordAnswer(e) {
      const zip = e.target.value;
      if (/\d{5}/.test(zip)) {
        this.choice = zip;
        this.$store.dispatch("interview/setNext", true);
      } else {
        this.$store.dispatch("interview/setNext", false);
      }
    }
  }
};
</script>
